"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../DomainObject");
/**
 * Description of form.
 *
 * @author Radek Beran
 */


var FormDefinition =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(FormDefinition, _DomainObject_1$Domai);

  /**
   * Constructs form definition.
   * @param fields definition of form fields
   */
  function FormDefinition(fields) {
    var _this;

    _classCallCheck(this, FormDefinition);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FormDefinition).call(this));
    _this.fields = fields;
    return _this;
  }

  return FormDefinition;
}(DomainObject_1.DomainObject);

exports.FormDefinition = FormDefinition;